<template>
  <div v-if="year">
    <v-menu
      ref="menu1"
      v-model="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="displayDate"
          append-icon="$calendar"
          v-bind="attrs"
          v-on="on"
          readonly
          solo
          :class="bgColor"
          :max-width="editorWidth"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="datePiker"
        :max="allowMaxDate"
        :min="allowMinDate"
        :active-picker.sync="activePicker"
        :allowed-dates="allowedDates"
        v-model="date"
        full-width
        no-title
        @click:year="saveYear"
        width="200"
      ></v-date-picker>
    </v-menu>
  </div>
  <div v-else-if="month">
    <v-menu
      ref="menu1"
      v-model="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="displayDate"
          append-icon="$calendar"
          v-bind="attrs"
          v-on="on"
          readonly
          solo
          :class="bgColor"
          :max-width="editorWidth"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="datePiker"
        type="month"
        :max="allowMaxDate"
        :min="allowMinDate"
        :active-picker.sync="activePicker"
        :allowed-dates="allowedDates"
        v-model="date"
        :max-width="editorWidth"
        no-title
        @click:month="saveMonth"
      ></v-date-picker>
    </v-menu>
  </div>
  <div v-else-if="menu">
    <v-menu
      ref="menu1"
      v-model="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="displayDate"
          append-icon="$calendar"
          @click:append="appendClick"
          readonly
          v-on="on"
          v-bind="attrs"
          solo
          :class="bgColor"
          slot-scope
          :clearable="clearable"
          color="white--text"
          :max-width="editorWidth"
          @click:clear="onCleared"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        :max="allowMaxDate"
        :min="allowMinDate"
        :allowed-dates="allowedDates"
        dense
        outlined
        slot-scope
        scrollable
        no-title
        :disabled="disabled"
        @input="onSelectDate"
        :events="functionEvents"
        event-color="green lighten-1"
      ></v-date-picker>
    </v-menu>
  </div>
  <div v-else>
    <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="date" width="290px">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="displayDate"
          append-icon="$calendar"
          @click:append="appendClick"
          readonly
          v-on="on"
          v-bind="attrs"
          solo
          :class="bgColor"
          slot-scope
          :clearable="clearable"
          color="white--text"
          :max-width="editorWidth"
          @click:clear="onCleared"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="date"
        :max="allowMaxDate"
        :min="allowMinDate"
        :allowed-dates="allowedDates"
        slot-scope
        scrollable
        no-title
        :disabled="disabled"
        @input="onSelectDate"
        :events="functionEvents"
        event-color="green lighten-1"
      ></v-date-picker>
    </v-dialog>

    <v-dialog ref="dialog2" v-model="timeModal" :return-value.sync="time" persistent>
      <v-time-picker
        v-if="timeModal"
        v-model="time"
        full-width
        :landscape="landscape"
        :events="arrayEvents"
        event-color="green lighten-1"
      >
        <v-spacer></v-spacer>
        <v-btn text color="white--text" @click="timeModal = false">Cancel</v-btn>
        <v-btn text color="white--text" @click="set()">OK</v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>
<!-- <template>
  <div>
    <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="date" persistent width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field v-model="displayDate" :label="`${label}`" append-icon="$calendar" readonly v-on="on" dense slot-scope=""></v-text-field>
      </template>
      <v-date-picker v-model="date" :max="allowMaxDate" :min="allowMinDate" no-title scrollable :disabled="disabled">	
        <v-spacer></v-spacer>	
        <v-btn text color="white--text" @click="dateModal = false">Cancel</v-btn>	
        <v-btn v-if="dateOnly == false" text color="white--text" @click="timeModal = true">OK</v-btn>	
        <v-btn v-else text color="white--text" @click="set()">OK</v-btn>	
      </v-date-picker>	
    </v-dialog>	
    <v-dialog ref="dialog2" v-model="timeModal" :return-value.sync="time" persistent width="290px">	
      <v-time-picker v-if="timeModal" v-model="time" full-width>	
        <v-spacer></v-spacer>	
        <v-btn text color="primary" @click="timeModal = false">Cancel</v-btn>	
        <v-btn text color="primary" @click="set()">OK</v-btn>	
      </v-time-picker>	
    </v-dialog>	
  </div>
</template>	 -->
<script>
import { getCurrentDate, getYearFormat, getMonthFormat } from '@/utils/common.js'
export default {
  name: 'DateTimePicker',
  props: {
    //2023-05-22 by lyj events 속성추가
    functionEvents: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: () => {
        return undefined
      }
    },
    dateOnly: {
      //datePicker만 사용할지
      type: Boolean,
      default: false
    },
    allowMaxDate: {
      //datePicker의 선택가능한 최대날짜 설정
      type: String,
      default: () => {
        return ''
      }
    },
    allowMinDate: {
      //datePicker의 선택가능한 최소날짜 설정
      type: String,
      default: () => {
        return ''
      }
    },
    firstDisplayDate: {
      //text-field에 표시하는 초기 display날짜 설정
      type: [String, Function],
      default: () => {
        return ''
      }
    },
    disabled: {
      //비활성화
      type: Boolean,
      default: false
    },
    year: {
      type: Boolean,
      default: false
    },
    month: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Boolean,
      default: false
    },
    allowedDates: {
      type: Function,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: 'editor_bg'
    },
    editorWidth: {
      type: Number,
      default: 200
    }
  },
  data: () => ({
    date: '',
    dateModal: false,
    time: '',
    timeModal: false,
    maxDate: '',
    minDate: '',
    displayDate: '',
    dateMenu: false,
    activePicker: null
  }),
  watch: {
    dateMenu(val) {
      if (this.year) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      } else if (this.month) {
        val && setTimeout(() => (this.activePicker = 'MONTH'))
      }
    },
    firstDisplayDate() {
      this.setFirstDisplayDate()
    }
  },
  mounted() {
    // this.setMaxDate()
    // this.setMinDate()
    this.setFirstDisplayDate()
  },
  methods: {
    appendClick() {
      this.dateModal = true
      this.dateMenu = true
    },
    set() {
      this.$emit('getDate', this.date)
      // this.date = this.date + ' ' + this.time
      this.displayDate = this.formatDate(this.date)
      if (this.menu) {
        this.$refs.menu1.save(this.date)
      } else {
        this.$refs.dialog.save(this.date)
        this.$refs.dialog2.save(this.time)
      }
    },
    // setMaxDate(){
    //   if(this.allowMaxDate != null) this.maxDate = this.allowMaxDate;
    //   else this.maxDate=''
    // },
    // setMinDate(){
    //   if(this.allowMinDate != null)  this.minDate = this.allowMinDate;
    //   else this.minDate=''
    // },
    setFirstDisplayDate() {
      if (this.firstDisplayDate != null && this.year) this.displayDate = getYearFormat(this.firstDisplayDate)
      else if (this.firstDisplayDate != null && this.month) this.displayDate = getMonthFormat(this.firstDisplayDate)
      else if (this.firstDisplayDate != null) this.displayDate = this.formatDate(this.firstDisplayDate)
      else this.displayDate = ''
    },
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      }
      if (date.indexOf('.') > -1) {
        const [year, month, day] = date.split('.')
        return `${year}.${month}.${day}`
      }
    },
    onCleared() {
      this.date = null
      this.$emit('getDate', this.date)
      if (this.menu) {
        this.$refs.menu1.save(this.date)
      } else {
        this.$refs.dialog.save(this.date)
        this.$refs.dialog2.save(this.time)
      }
      this.displayDate = ''
    },
    onSelectDate(e) {
      this.$emit('getDate', this.date)
      // this.date = this.date + ' ' + this.time
      this.displayDate = this.formatDate(this.date)
      if (this.menu) {
        this.$refs.menu1.save(this.date)
      } else {
        this.$refs.dialog.save(this.date)
        this.$refs.dialog2.save(this.time)
      }
    },

    saveYear(year) {
      this.date = `${year}-01`
      this.displayDate = year
      this.$refs.menu1.save(year)
      this.$emit('getDate', year)
    },
    saveMonth(month) {
      this.date = `${month}-01`
      this.displayDate = month.replaceAll('-', '.')
      this.$refs.menu1.save(month)
      this.$emit('getDate', month)
    }
  }
}
</script>
